var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'custom-button': true,
    'custom-button-small': _vm.size === 'small',
    'custom-button-large': _vm.size === 'large',
    'custom-button-gradient': _vm.gradient,
    'custom-button-disabled': _vm.disabled,
    gray: _vm.gray,
    white: _vm.white,
    pink: _vm.pink,
    radius: _vm.radius,
  },style:(("" + _vm.customStyles)),on:{"click":_vm.emitClick}},[_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }